import { render, staticRenderFns } from "./DetailPermohonanPerbaikanPersyaratan.vue?vue&type=template&id=2cc2a946&"
import script from "./DetailPermohonanPerbaikanPersyaratan.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanPerbaikanPersyaratan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports